import { MediaImageStandard, Typography } from 'components/Contentful'
import classNames from 'classnames'
import { useMemo, memo } from 'react'
import { withUuid } from '@/utils/shared'
import { TABS_ID_PREFIX, TAB_QUOTE_STYLE, LENDING_VARIANT } from './constants'
import { BubbleComponent } from './BubbleComponent'

const ItemComponentCarousel = memo(({ item, index, idPrefix, tabStyle }) => {
  let imgHeight = 500
  let imgWidth = 629
  if (idPrefix === TABS_ID_PREFIX) {
    imgHeight = 441
    imgWidth = 339
  } else if (tabStyle === LENDING_VARIANT) {
    imgHeight = 531
    imgWidth = 753
  } else {
    imgHeight = 500
    imgWidth = 629
  }

  const bubblesList = useMemo(() => withUuid(item?.config?.bubbles), [item?.config?.bubbles])

  return (
    <div className="flex-1">
      <div
        className={
          tabStyle === LENDING_VARIANT
            ? 'flex items-end justify-center relative'
            : 'mt-2 py-1 flex items-center justify-center relative mx-2 lg:mx-0'
        }
        data-testid="item-component-carousel-container"
      >
        <div
          className={classNames(
            idPrefix === TABS_ID_PREFIX
              ? tabStyle === TAB_QUOTE_STYLE
                ? `overflow-hidden md:overflow-auto max-h-[330px] rounded-md relative  md:static md:max-h-none child:mt-2`
                : `overflow-hidden md:overflow-auto max-h-[220px] rounded-md relative  md:static md:max-h-none child:mt-2`
              : 'w-full lg:w-auto',
            tabStyle === LENDING_VARIANT && 'lg:contents max-h-[265px]'
          )}
        >
          <MediaImageStandard
            content={item?.image}
            className={
              idPrefix === TABS_ID_PREFIX
                ? `object-contain w-full rounded-md max-w-md ${
                    tabStyle === LENDING_VARIANT
                      ? 'pl-3 lg:max-w-2xl object-top lg:object-bottom'
                      : 'lg:max-w-xl object-top '
                  } mt-[${item?.config?.customTopMobile || '-10px'}] sm:mt-0`
                : 'w-full h-auto max-w-md lg:max-w-xl'
            }
            height={imgHeight}
            width={imgWidth}
            alt={item?.image?.title}
            fetchPriority="high"
            preload={idPrefix === TABS_ID_PREFIX ? true : index === 0}
          />
        </div>
        {bubblesList?.map((bubble, index) => (
          <BubbleComponent key={bubble?.uuid} bubble={bubble} index={index} />
        ))}
      </div>
      {tabStyle !== LENDING_VARIANT && (
        <div className="mt-2 flex items-center justify-center">
          <div
            className="max-w-md lg:pb-7"
            data-testid="item-component-carousel-disclaimer-container"
          >
            {item?.disclaimer && (
              <Typography
                content={item?.disclaimer}
                variant="bodyXs"
                data-testid="item-component-carousel-disclaimer"
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
})
ItemComponentCarousel.displayName = 'ItemComponentCarousel'

export { ItemComponentCarousel }
